__turbopack_context__.v({
  "bar": "BlurredPlaceholder-module__8nThPG__bar",
  "circle": "BlurredPlaceholder-module__8nThPG__circle",
  "icon": "BlurredPlaceholder-module__8nThPG__icon",
  "iconCell": "BlurredPlaceholder-module__8nThPG__iconCell",
  "list": "BlurredPlaceholder-module__8nThPG__list",
  "pill": "BlurredPlaceholder-module__8nThPG__pill",
  "row": "BlurredPlaceholder-module__8nThPG__row",
});
